import { timeoutPromise } from '.';
import { callFunction } from './FirebaseUtils';

export const waitForJobCompletion = async (jobId: string): Promise<boolean> => {
  let status = 'SUBMITTED';
  while (status === 'SUBMITTED' || status === 'PROGRESSING') {
    status = (await callFunction('checkMediaConvertJobStatus', { jobId })).data;
    await timeoutPromise(2000);
  }
  if (status === 'ERROR') {
    throw new Error('Failed converting the video');
  }
  return status === 'COMPLETE';
};



// WEBPACK FOOTER //
// ./src/utils/AWSMediaConvertUtils.ts